<template>
  <StatusLabel :tone="tone" :label="t(`mail_campaign_status_${status}`)" />
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const props = defineProps<{ status: string }>();
const { t } = useI18n();

// Spec §5.1: scheduled and on its way is good to know (ice), sent went well (mint), a draft or a
// cancelled one is at rest (ash): nothing here blocks, so no plum
const tone = computed(() => ({
  draft: 'ash',
  scheduled: 'ice',
  sending: 'ice',
  sent: 'mint',
  cancelled: 'ash',
} as const)[props.status as 'draft'] ?? 'ash');
</script>
